export const categories = [
    { id: 172507, name: 'Etický kodex', wo: true },
    { id: 196837, name: 'Formuláře', wo: false },
    { id: 59257, name: 'Metodiky MMB', wo: true },
    { id: 59256, name: 'Nařízení', wo: true },
    { id: 59258, name: 'Opatření obecné povahy', wo: true },
    { id: 59259, name: 'Organizační řád MMB', wo: true },
    { id: 59264, name: 'Rozpočet', wo: true },
    { id: 59263, name: 'Statuty komisí a výborů', wo: true },
    { id: 59253, name: 'Vyhlášky', wo: true },
    { id: 59254, name: 'Zápisy ze schůze RMB', wo: true },
    { id: 59260, name: 'Zápisy ze schůzí výboru ZMB - finanční', wo: true },
    { id: 59261, name: 'Zápisy ze schůzí výboru ZMB - kontrolní', wo: true },
    { id: 59262, name: 'Zápisy ze schůzí výboru ZMB - národnostní menšiny', wo: true },
    { id: 59255, name: 'Zápisy ze zasedání ZMB', wo: true },
];
export const years = () => {
    const yearOptions = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1987; year--) {
        yearOptions.push({ id: year, name: year });
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return yearOptions;
};
export const validity = [
    { id: false, name: 'Jen zrušené' },
    { id: true, name: 'Jen platné' },
];
